export const ADD_USER = "ADD_USER";
export const ADD_FIREBASE_TOKEN = "ADD_FIREBASE_TOKEN";
export const REMOVE_FIREBASE_TOKEN = "REMOVE_FIREBASE_TOKEN";

export const addUser = (user) => {
  return {
    type: ADD_USER, 
    user
  }
}

export const addFirebaseToken = (token) => {
  return {
    type: ADD_FIREBASE_TOKEN,
    token
  }
}

export const removeFirebaseToken = (token) => {
  return {
    type: REMOVE_FIREBASE_TOKEN
  }
}


// WEBPACK FOOTER //
// ./src/actions/user.js